import axios from "axios";
import store from "./redux";

import { setCollection } from "../store/collectionSlice";
import { Pagination } from "../utils/Pagination";
import { LANG } from "./i18next";

export enum COLLECTION_TYPE {
  experience = "experience",
  hotel = "hotel",
}

export enum COLLECTION_PERMISSIONS {
  admin = "admin",
  update = "update",
  memebers = "memebers",
  census = "census",
  preset = "preset",
  create_nft = "create_nft",
  update_nft = "update_nft",
  delete_nft = "delete_nft",
  sale = "sale",
  set_payment_method = "set_payment_method",
  view_payment_data = "view_payment_data",
  receive_notifications = "receive_notifications",
  stealth = "stealth",
  view_events = "view_events",
}

export interface collectionMember {
  email: string;
  permissions: Array<COLLECTION_PERMISSIONS>;
  isInviteAccepted: boolean;
}

export type experienceCensusInfo = {
  [lang in LANG]?: {
    experiences?: {
      name: string;
      description: string;
      hostName?: string;
      hostDescription?: string;
      images: string[];
    }[];
  };
};

export type hotelCensusInfo = {
  [lang in LANG]?: {
    description?: string;
    services?: { icon: string; value: string }[];
    rooms?: {
      name: string;
      services?: { icon: string; value: string; data: string }[];
      traits?: { icon: string; value: string }[];
      images?: string[];
    }[];
    poi?: {
      icon: string;
      value: string;
      text: string;
    }[];
    policies?: {
      title: string;
      text: string;
    }[];
    reviews?: {
      vote?: number;
      voteText?: string;
      date?: string;
      context?: string;
      title: string;
      text: string;
    }[];
    reviewSummary?: {
      vote?: number;
      voteText?: string;
      cleanlinessVote?: number;
      hotelConditionVote?: number;
      roomConfortVote?: number;
      serviceStaffVote?: number;
    };
  };
};

export type hotelCensusLocationType =
  | "sea"
  | "mountain"
  | "city"
  | "lake"
  | "wellness";

export type hotelCensus = {
  type?: "hotel";

  name?: string;
  stars?: string;
  location?: any;
  locationType?: hotelCensusLocationType;
  email?: string;
  website?: string;
  firstName?: string;
  secondName?: string;
  note?: string; // deprecated
  images?: Array<string>;

  info?: hotelCensusInfo;

  hotelsComSlug?: string;
  hotelsComId?: string;
};

export type hotelStats = {
  averageBookingPrice?: number;
  averageNumberOfDaysPerStay?: number;
  averageOccupancyPercentage?: number;
  directBookingPercentage?: number;
  nonRefoundableSalesPercentage?: number;
};

// Exp - start
/*
export type experienceCategory =
  | "sport"
  | "adrenaline"
  | "city"
  | "wellness";
*/

export enum ExperienceCategory {
  sport = "Sport",
  adrenaline = "Adrenaline",
  city = "City",
  wellness = "Wellness",
}

export type experienceCensus = {
  type?: "experience";

  name?: string;
  email?: string;
  website?: string;
  location?: any;

  category?: ExperienceCategory;

  // firstName?: string;
  // secondName?: string;
  note?: string; // deprecated
  // images?: Array<string>;

  // questo tipo non ha bisogno di queste proprietà...
  // stars?: string;
  // info?: null;
  // hotelsComSlug?: string;
  // hotelsComId?: string;
};

// Exp - end

export interface iCollection {
  _id: string;
  name: string;
  groupId: string;
  gold: boolean; // TODO deprecable?
  type: string;
  paymentMethodId: string;
  members: Array<collectionMember>;

  censusStats?: hotelStats;
  census?: hotelCensus;
  images: Array<string>;

  nftCount?: number;
  lastNftCreatedAt?: any;
  subscriptionStatus?: string;

  feeOnCreation?: number;
  feeMonthly?: number;
  feeFixedOnCreation?: number;

  trialEndDate?: Date;

  bonusCredits?: number;

  isActive: boolean;

  checkBeforeSale?: boolean;

  liveDate?: any;

  _createdAt: any;
}

export const collectionRoles: Array<{
  name: string;
  permissions: Array<COLLECTION_PERMISSIONS>;
  onlyAdmin?: boolean;
}> = [
  {
    name: "moderator",
    permissions: [
      COLLECTION_PERMISSIONS.update,
      COLLECTION_PERMISSIONS.memebers,
      COLLECTION_PERMISSIONS.create_nft,
      COLLECTION_PERMISSIONS.delete_nft,
      COLLECTION_PERMISSIONS.update_nft,
      COLLECTION_PERMISSIONS.set_payment_method,
      COLLECTION_PERMISSIONS.view_payment_data,
      COLLECTION_PERMISSIONS.census,
      COLLECTION_PERMISSIONS.receive_notifications,
      COLLECTION_PERMISSIONS.sale,
      COLLECTION_PERMISSIONS.view_events,
    ],
  },
  {
    name: "rm",
    permissions: [
      COLLECTION_PERMISSIONS.update,
      COLLECTION_PERMISSIONS.memebers,
      COLLECTION_PERMISSIONS.set_payment_method,
      COLLECTION_PERMISSIONS.view_payment_data,
      COLLECTION_PERMISSIONS.census,
      COLLECTION_PERMISSIONS.receive_notifications,
      COLLECTION_PERMISSIONS.sale,
      COLLECTION_PERMISSIONS.view_events,
    ],
  },
  {
    name: "rmnopayments",
    permissions: [
      COLLECTION_PERMISSIONS.update,
      COLLECTION_PERMISSIONS.memebers,
      COLLECTION_PERMISSIONS.census,
      COLLECTION_PERMISSIONS.receive_notifications,
      COLLECTION_PERMISSIONS.sale,
      COLLECTION_PERMISSIONS.view_events,
    ],
  },
  {
    name: "editor",
    permissions: [
      COLLECTION_PERMISSIONS.update,
      COLLECTION_PERMISSIONS.create_nft,
      COLLECTION_PERMISSIONS.update_nft,
      COLLECTION_PERMISSIONS.census,
    ],
  },
  {
    name: "notificable",
    permissions: [COLLECTION_PERMISSIONS.receive_notifications],
  },
  {
    name: "api",
    permissions: [
      COLLECTION_PERMISSIONS.create_nft,
      COLLECTION_PERMISSIONS.update_nft,
    ],
  },
  {
    name: "member",
    permissions: [],
  },
  {
    name: "stealth_events",
    permissions: [
      COLLECTION_PERMISSIONS.stealth,
      COLLECTION_PERMISSIONS.view_events,
    ],
    onlyAdmin: true,
  },
  {
    name: "stealth_editor",
    permissions: [
      COLLECTION_PERMISSIONS.stealth,
      COLLECTION_PERMISSIONS.preset,
      COLLECTION_PERMISSIONS.census,
      COLLECTION_PERMISSIONS.update,
    ],
    onlyAdmin: true,
  },
];

export interface loadCollectionProps {
  page?: number;
  size?: number;
  total?: number;
  groupId?: string;
  gold?: boolean;
  query?: any;
  sort?: any;
}

export async function getCollections({
  page = 1,
  size = 25,
  groupId = "",
  gold = false,
  query = {},
  sort = { name: 1 },
}): Promise<Pagination<iCollection>> {
  let url = `/collection/paginate?page=${page}&size=${size}`;

  if (groupId) {
    url += "&groupId=" + groupId;
  }

  if (typeof gold === "boolean") {
    if (gold) url += "&gold=true";
    else url += "&gold=false";
  }

  if (query) {
    url += "&query=" + JSON.stringify(query);
  }

  if (sort) {
    url += "&sort=" + JSON.stringify(sort);
  }

  const response = await axios.get(url);
  return response.data;
}

export async function refreshStoredCollection(
  id: string
): Promise<iCollection> {
  const collection = await getCollection(id);
  store.dispatch(setCollection(collection));
  return collection;
}

export async function createCollection(payload: any): Promise<iCollection> {
  const response = await axios.post("/collection", payload);
  return response.data;
}

export async function patchCollection(payload: any): Promise<iCollection> {
  const response = await axios.patch("/collection", payload);
  return response.data;
}

export async function getCollection(id: string): Promise<iCollection> {
  const response = await axios.get("/collection/" + id);
  return response.data;
}

// seems to be duplicated
export async function updateCollection(payload: any): Promise<iCollection> {
  const response = await axios.patch("/collection/", payload);
  return response.data;
}

export async function inviteMemberToCollection(
  payload: any
): Promise<iCollection> {
  const response = await axios.post("/collection/member", payload);
  return response.data;
}

export async function acceptInviteCollection(payload: any) {
  const response = await axios.post("/collection/join", payload);
  return response.data;
}

export async function declineInviteCollection(payload: any) {
  const response = await axios.post("/collection/decline", payload);
  return response.data;
}

export async function removeMemberFromCollection(payload: any): Promise<any> {
  const response = await axios.delete("/collection/member", { data: payload });
  return response.data;
}

export async function setCollectionPermissionsPerUser(
  payload: any
): Promise<any> {
  const response = await axios.patch("/collection/member", payload);
  return response.data;
}

export async function leaveCollection(payload: any) {
  const response = await axios.post("/collection/leave", payload);
  return response.data;
}

export async function deleteCollection(payload: any) {
  const response = await axios.delete("/collection", { data: payload });
  return response.data;
}

export async function transferCollection(payload: any) {
  const response = await axios.patch("/collection/transfer-ownership", payload);
  return response.data;
}

export async function setTrialDate(payload: any) {
  const response = await axios.post("/collection/trial", payload);
  return response.data;
}

export async function getCollectionCensusInfoHotelsCom(payload: any) {
  const response = await axios.post("/hotelscom/all-info", payload);
  return response.data;
}

export async function getCollectionCensusInfoRoomsHoltelsCom(payload: any) {
  const response = await axios.post("/hotelscom/rooms", payload);
  return response.data;
}

export async function getCollectionCensusInfoReviewsHoltelsCom(payload: any) {
  const response = await axios.post("/hotelscom/reviews", payload);
  return response.data;
}

export async function autofillCollectionCensusInfo(
  collection: iCollection,
  lang: LANG,
  override = false
): Promise<hotelCensusInfo> {
  let info: hotelCensusInfo = {};

  if (collection.census?.type !== "hotel") return {};

  if (!collection.census) return info;
  if (!collection.census.hotelsComSlug && !collection.census.hotelsComId)
    return info;

  if (collection.census?.info)
    info = JSON.parse(JSON.stringify(collection.census.info));

  Object.values(LANG).forEach((lang) => {
    if (!info[lang]) info[lang] = {};

    if (!info[lang]?.services) info[lang]!.services = [];
    if (!info[lang]?.rooms) info[lang]!.rooms = [];
    if (!info[lang]?.poi) info[lang]!.poi = [];
    if (!info[lang]?.policies) info[lang]!.policies = [];
    if (!info[lang]?.reviews) info[lang]!.reviews = [];
    if (!info[lang]?.reviewSummary) info[lang]!.reviewSummary = {};
  });

  const hotelInfo = await getCollectionCensusInfoHotelsCom({
    lang: lang,
    hotelsComId: collection.census.hotelsComId,
    hotelsComSlug: collection.census.hotelsComSlug,
  });
  const description =
    hotelInfo.info?.propertyContentSectionGroups.aboutThisProperty.sections[0]
      .bodySubSections[0].elements[0].items[0].content.text;
  if (description && (override || !info[lang]?.description))
    info[lang]!.description = description;

  const services =
    hotelInfo.summary.summary?.amenities?.topAmenities?.items?.map(
      (service: any) => ({
        icon: service.icon?.token,
        value: service.text,
      })
    );
  if (
    services &&
    (override || !info[lang]?.services || !info[lang]?.services?.length)
  )
    info[lang]!.services = services;

  const poi = hotelInfo.details.summary?.nearbyPOIs?.items?.map((poi: any) => ({
    icon: poi.icon?.token,
    value: poi.text,
    text: poi.moreInfo,
  }));
  if (poi && (override || !info[lang]?.poi || !info[lang]?.poi?.length))
    info[lang]!.poi = poi;

  const policies: any[] = [];
  const propertyPolicies = hotelInfo.details.summary?.policies;
  for (const key in propertyPolicies) {
    if (propertyPolicies.hasOwnProperty(key)) {
      const policy = propertyPolicies[key];
      const title = policy?.title || key;

      if (policy?.body && policy.body.length > 0) {
        const textListBody = policy.body.map((item: any) => `${item}`);

        policies.push({
          title: title,
          text: `${textListBody.join(", ")}`,
        });
      } else if (Array.isArray(policy) && policy.length > 0) {
        const textList = policy.map((item: any) => `${item}`);
        policies.push({
          title: title,
          text: `${textList.join(", ")}`,
        });
      }
    }
  }
  if (
    policies &&
    (override || !info[lang]?.policies || !info[lang]?.policies?.length)
  )
    info[lang]!.policies = policies;

  const roomsInfo = await getCollectionCensusInfoRoomsHoltelsCom({
    lang: lang,
    hotelsComId: collection.census.hotelsComId,
    hotelsComSlug: collection.census.hotelsComSlug,
  });
  const rooms = roomsInfo.rooms.units.map((unit: any) => {
    return {
      name: unit?.header?.text,

      images: unit?.unitGallery?.gallery?.map(
        (imageObj: any) => imageObj?.image?.url
      ),

      services: unit?.roomAmenities?.bodySubSections?.[0].contents?.map(
        (amenity: any) => {
          return {
            value: amenity?.header?.text,
            icon: amenity?.header?.icon?.token,
            data: amenity?.items[0].content.text,
          };
        }
      ),

      traits: unit?.features?.map((feature: any) => {
        return {
          value: feature?.text,
          icon: feature?.graphic?.token,
        };
      }),
    };
  });
  if (rooms && (override || !info[lang]?.rooms || !info[lang]?.rooms?.length))
    info[lang]!.rooms = rooms;

  const { reviewsSummary, reviews } =
    await getCollectionCensusInfoReviewsHoltelsCom({
      lang: lang,
      hotelsComId: collection.census.hotelsComId,
      hotelsComSlug: collection.census.hotelsComSlug,
    });

  if (
    reviewsSummary &&
    (override || info[lang]?.reviewSummary || !info[lang]?.reviewSummary?.vote)
  )
    info[lang]!.reviewSummary = {
      vote: Number(Number(reviewsSummary.averageOverallRating.raw).toFixed(2)),
      voteText: `${Number(reviewsSummary.averageOverallRating.raw).toFixed(
        1
      )}/10`,
      cleanlinessVote: Number(
        Number(reviewsSummary.cleanliness.raw).toFixed(2)
      ),
      hotelConditionVote: Number(
        Number(reviewsSummary.hotelCondition.raw).toFixed(2)
      ),
      roomConfortVote: Number(
        Number(reviewsSummary.roomComfort.raw).toFixed(2)
      ),
      serviceStaffVote: Number(
        Number(reviewsSummary.serviceAndStaff.raw).toFixed(2)
      ),
    };

  if (
    reviews &&
    (override || !info[lang]?.reviews || !info[lang]?.reviews?.length)
  )
    info[lang]!.reviews = reviews.map((r: any) => {
      let date: any;

      try {
        date = new Date(r.submissionTimeLocalized);
      } catch (error) {}

      return {
        vote: Number(String(r.reviewScoreWithDescription.value).split("/")[0]),
        voteText: r.reviewScoreWithDescription.accessibilityLabel,
        date: date,
        context: r.stayDuration,
        title: r.title,
        text: r.text,
      };
    });

  return info;
}

export interface iCreateFakeHotelSupply {
  collectionId: string;
  guestsAmount: number;
  guestsKidsAmount: number;
  nightsAmount: number;
  startFromDate: string;
  roomType: string;
  owner: string;
  putForSale: boolean;
  discountFromMarket: number;
  price: number;
}

export async function createFakeHotelSupply(payload: iCreateFakeHotelSupply) {
  console.log(payload);
  const respones = await axios.post(
    "/collection/create-hotel-artificial-supply",
    payload
  );
  return respones.data;
}
